import { render, staticRenderFns } from "./RepairRecord.vue?vue&type=template&id=4e5523f4&scoped=true&"
import script from "./RepairRecord.vue?vue&type=script&lang=js&"
export * from "./RepairRecord.vue?vue&type=script&lang=js&"
import style0 from "./RepairRecord.vue?vue&type=style&index=0&id=4e5523f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5523f4",
  null
  
)

export default component.exports